import React from 'react';
import Button from '../components/button.js';
import Logo from '../images/jcoyne-logo-medium.png';
import LogoHTML from '../images/html-logo.png';
import LogoCSS from '../images/css-logo.png';
import LogoJS from '../images/js-logo.png';

export default function Home() {

    return (
        <div id="home">
            <div className="homediv" id="hero">
                <ul id="homecarousel">
                    <li><span className="bold"><p>J. Coyne</p></span></li>
                    <li><span className="bold"><p>Web Development</p></span></li>
                    <li><span><img src={Logo} alt="JCoyne Logo" /></span></li>
                </ul>
            </div>
            <div className="homediv" id="blurb">
                <div className="tripleflex">
                    <div className="tripleitem">
                        <img src={LogoHTML} alt="HTML" />
                    </div>
                    <div className="tripleitem">
                        <img src={LogoCSS} alt="CSS" />
                    </div>
                    <div className="tripleitem">
                        <img src={LogoJS} alt="JavaScript" />
                    </div>
                </div>
                <h3>Welcome to my site! I'm a Web Developer committed to and passionate about making beautiful and responsive websites.</h3>
            </div>
            <div className="homediv" id="listskills">
                <p>Proficient in HTML, CSS, JavaScript, React, Node.js, Nextjs, PHP, MySQL, Python, and Kotlin. Knowledgeable in Adobe Photoshop, Adobe Illustrator, Adobe Indesign, and the Google & Microsoft suite of programs.</p>
            </div>
            <div className="homediv" id="buttonpages">
                <div className="tripleflex">
                    <div className="tripleitem">
                        <Button buttonsize="bigbutton" buttonID="homeabout" buttonsource="/about" buttonname="About Me" buttontarget="_self" />
                    </div>
                    <div className="tripleitem">
                        <Button buttonsize="bigbutton" buttonID="homeportfolio" buttonsource="/portfolio" buttonname="My Portfolio" buttontarget="_self" />
                    </div>
                    <div className="tripleitem">
                        <Button buttonsize="bigbutton" buttonID="homecontact" buttonsource="/contact" buttonname="Contact Me" buttontarget="_self" />
                    </div>
                </div>
            </div>
        </div>
    )
}